RivalIQ.apps.Analyze.module('views', function (views, App, Backbone, Marionette, $, _) {

    'use strict';

    views.TimeChart = views.Chart.extend({
        className: 'x-graph text-center',
        companyDisplayLimit: 15,
        onShow: function () {

            const me = this;
            const data = me.getData();

            const graph = me.graph = me.getGraph();
            const focusCompanyId = me.getProp('focusCompanyId');
            const focusCompanyOnly = me.getProp('focusCompanyOnly');
            const showBottomLegend = me.getProp('showBottomLegend');
            const omitGraphTitle = me.getProp('omitGraphTitle');

            graph.timeAnalysisMode = me.getTimeAnalysisMode();
            graph.dataType = me.getDataType();
            graph.isVolumetric = me.isVolumetric();
            graph.setTarget(me.el);
            graph.setMarkerSize(1);
            graph.setMargins(me.getMargins());
            graph.setFocusCompanyId(focusCompanyId);
            graph.setFocusCompanyOnly(focusCompanyOnly);
            graph.setData(data);
            graph.tooltipSubmetrics = me.getTooltipSubmetrics();
            graph.setTickSize(me.getTickSize());
            graph.setDataDateRange(me.getDataDateRange());
            graph.setWidth(me.getWidth());
            graph.setHeight(me.getHeight(data));
            graph.setYLabel(me.getLabelY());
            graph.setFormatX(me.getFormatX());
            graph.setPopoverFormatX(me.getPopoverFormatX());
            graph.setTimePeriod(me.getTimePeriod());
            graph.setHideActions(me.dashboardModel.isExporting());
            graph.setHideExcluded(me.dashboardModel.isExporting());
            graph.setShowBottomLegend(showBottomLegend);
            graph.setOmitTitle(omitGraphTitle);
            graph.setOmitLegend(focusCompanyOnly);
            graph.setIsContentLinkable(me.isContentLinkable());
            graph.setLimit(me.companyDisplayLimit);
            graph.yAxisFormat = me.getYAxisFormat();

            graph.render();

            return me;
        },

        getTooltipSubmetrics: function () {
            return [];
        },

        // NOTE this is legacy
        getTimePeriod: function () {
            const me = this;
            return me.companyData.getTimePeriod();
        },

        getGraph: function () {
            const me = this;

            if (!me.timeGraph) {
                me.timeGraph = new RivalIQ.graph.TimeSeries();
                me.listenTo(me.timeGraph, 'analyze-content', _.bind(me.showContentModal, me));
                me.listenTo(me.timeGraph, 'exclusion:added', me.onExclusionAdded);
                me.listenTo(me.timeGraph, 'exclusion:removed', me.onExclusionRemoved);
            }

            return me.timeGraph;
        },
        onExclusionAdded: function (metric) {
            const me = this;
            const excluded = _.union(me.getProp('exclusions'), [metric]);
            // NOTE we set the props silently b/c the graph redraws itself and
            // we dont want to redraw the whole graph
            me.setProps('exclusions', excluded, {
                silent: true
            });

            RivalIQ.execute('tracking:push:auth', RivalIQ.tracking.metric.GraphLegendClicked, {
                channel: me.getProp('channel'),
                freeDimension: 'companyId',
                chartType: 'lineSeries'
            });
        },
        onExclusionRemoved: function (metric) {
            const me = this;
            const excluded = _.without(me.getProp('exclusions'), metric);
            // NOTE we set the props silently b/c the graph redraws itself and
            // we dont want to redraw the whole graph
            me.setProps('exclusions', excluded, {
                silent: true
            });

            RivalIQ.execute('tracking:push:auth', RivalIQ.tracking.metric.GraphLegendClicked, {
                channel: me.getProp('channel'),
                freeDimension: 'companyId',
                chartType: 'lineSeries'
            });
        },
        getWidth: function () {
            const me = this;
            const width = views.Chart.prototype.getWidth.apply(me, arguments);
            // TODO setting the margin on these charts seems pretty busted
            // for now reduce the given width to give the chart some margin
            return width - 40;
        },
        getHeight: function (data) {
            const me = this;

            const height = me.getProp('height');
            if (height) {
                return height;
            }

            return Math.max(me.minHeight,
                Math.min(data.length, me.companyDisplayLimit) * me.itemHeight);
        }
    });
});
